export { imageNodeName, ImageAttr } from './ImageSpecs';
export const addImageAction = 'addImage';
